module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Renens-e0020fa90423025d0bad7808ed8428fc.svg";